export const DEFAULT_INSURANCE_ID = '0'

export const MODAL_NAMES = {
  BACK_MARKET_PROMISE: 'BACK_MARKET_PROMISE',
}
